import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { EditIcon, DuplicateIcon } from '../../../../images/icons/WrapSvg';

class Index extends React.Component {
    handleEdit = () => {
        this.props.history.push(`/xef/locals/${this.props.id}`);
    };

    render() {
        const { intl, anchorEl, handleClose } = this.props;
        return (
            <Menu
                id="recipe-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem className={'bg_ice_blue'} onClick={this.handleEdit}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <EditIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_edit_menuitem' })}
                    />
                </MenuItem>
                <MenuItem className={'bg_ice_blue'} onClick={(event) => handleClose('duplicated')}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <DuplicateIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({ id: 'popup_clone_menuitem' })}
                    />
                </MenuItem>
            </Menu>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default withRouter(injectIntl(Index));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/locals/TableMenu.js